// components/LogoHeader.jsx
const LogoHeader = () => (
    <div style={{ textAlign: 'center', marginTop: '2rem', padding: '0 1rem', width: '100%', boxSizing: 'border-box' }}>
        <h1 style={{ fontSize: 'clamp(1.5rem, 6vw, 2rem)', fontWeight: 'bold' }}>I-Point</h1>
        <p style={{ color: '#d6fff6' }}>Easy Charging Solution</p>
    </div>
);

export default LogoHeader;
